import { api } from './api';

export type CopilotEnabledResponse = { ok: boolean; enabled: boolean };

export type CopilotSession = {
  id: string;
  created_at?: string | null;
  updated_at?: string | null;
  scope?: { org_id?: string | null; site_id?: string | null; device_id?: string | null };
  status?: 'active' | 'closed' | string;
};

export type CopilotConfirmation = {
  confirmation_id: string;
  session_id: string;
  plan_fingerprint: string;
  fingerprint: string;
  expires_at?: string | null;
  status?: string;
};

export type CopilotPlanAction = {
  runbook_id: string;
  label?: string;
  inputs?: Record<string, any>;
  requires_confirmation?: boolean;
  fingerprint: string;
};

export type CopilotPlan = {
  schema_version: string;
  message: string;
  resolved_scope: { org_id?: string | null; site_id?: string | null; device_id?: string | null };
  template_version: string;
  actions: CopilotPlanAction[];
  guidance?: string | null;
};

export type CopilotPostMessageResponse = {
  ok: boolean;
  plan: CopilotPlan;
  plan_fingerprint: string;
  confirmations: CopilotConfirmation[];
};

export type CopilotConfirmResponse = {
  ok: boolean;
  results: any[];
  templates_version?: string;
};

export const copilotApi = {
  async getEnabled(): Promise<CopilotEnabledResponse> {
    const res = await api.get('/api/v1/copilot/enabled');
    return res.data as CopilotEnabledResponse;
  },

  async createSession(input: { scope?: { org_id?: string; site_id?: string; device_id?: string }; mode?: 'embedded' | string }): Promise<{ ok: boolean; session: CopilotSession }> {
    const res = await api.post('/api/v1/copilot/sessions', { scope: input.scope || {}, mode: input.mode || 'embedded' });
    return res.data as { ok: boolean; session: CopilotSession };
  },

  async getSession(sessionId: string): Promise<any> {
    const res = await api.get(`/api/v1/copilot/sessions/${encodeURIComponent(sessionId)}`);
    return res.data;
  },

  async postMessage(sessionId: string, message: string): Promise<CopilotPostMessageResponse> {
    const res = await api.post(`/api/v1/copilot/sessions/${encodeURIComponent(sessionId)}/messages`, { message });
    return res.data as CopilotPostMessageResponse;
  },

  async confirm(sessionId: string, input: { confirmation_id?: string; selections?: string[] }): Promise<CopilotConfirmResponse> {
    const res = await api.post(`/api/v1/copilot/sessions/${encodeURIComponent(sessionId)}/confirm`, input);
    return res.data as CopilotConfirmResponse;
  },
};

